import { css } from '@emotion/react'
import { ModalBody, Table, TableBody, TableHead, TableHeader, TableRow, VFlow } from 'bold-ui'
import { Dispatch, SetStateAction } from 'react'

import { BundleFhirAssinatura } from './AssinadorRepmModal'
import { AssinadorRepmModalBodySection } from './AssinadorRepmModalBodySection'

interface AssinadorRepmModalTableProps {
  bundlesFhirAssinatura: readonly BundleFhirAssinatura[]
  atendimentoId: ID
  setBundlesFhirAssinatura: Dispatch<SetStateAction<BundleFhirAssinatura[]>>
}

export const AssinadorRepmModalBody = (props: AssinadorRepmModalTableProps) => {
  const { bundlesFhirAssinatura, atendimentoId, setBundlesFhirAssinatura } = props

  const styles = createStyles()

  return (
    <ModalBody>
      <VFlow vSpacing={0}>
        <Table style={styles.tabela}>
          <TableHead>
            <TableRow>
              <TableHeader style={styles.columnDocumento}>Documento REPM</TableHeader>
              <TableHeader style={styles.columnSituacao}>Situação</TableHeader>
              <TableHeader style={styles.columnAssinatura} />
            </TableRow>
          </TableHead>
          <TableBody>
            {bundlesFhirAssinatura.map((bundleFhirAssinatura) => (
              <AssinadorRepmModalBodySection
                key={bundleFhirAssinatura.id}
                atendimentoId={atendimentoId}
                bundleFhirAssinatura={bundleFhirAssinatura}
                setBundlesFhirAssinatura={setBundlesFhirAssinatura}
              />
            ))}
          </TableBody>
        </Table>
      </VFlow>
    </ModalBody>
  )
}

const createStyles = () => ({
  tabela: css`
    margin-top: 0.5rem;
  `,
  columnDocumento: css`
    width: 60%;
  `,
  columnSituacao: css`
    width: 30%;
  `,
  columnAssinatura: css`
    width: 10%;
  `,
})
